import { render } from "./PurInvoiceCard.vue?vue&type=template&id=99a4121c"
import script from "./PurInvoiceCard.vue?vue&type=script&lang=js"
export * from "./PurInvoiceCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__